<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        :title="currentLanguageLabel"
        v-bind="attrs"
        v-on="on"
        :data-test="'language-selector-btn'"
      >
        <PhTranslate :size="18" />
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="lang in availableLanguages"
        :key="lang.code"
        :data-test="`language-option-${lang.code}`"
        @click="selectLanguage(lang.code)"
      >
        <v-list-item-title>
          <span class="mr-2">{{ lang.flag }}</span>{{ lang.label }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// Vuex
import { OPTIONS_STORE_LOCALE } from '@/vuex/module/locale';

// Constants
import { VUETIFY_LOCALE_MAP, applyDocumentLocale, clearUrlLocale } from '@/constants/locale-constants';

const AVAILABLE_LANGUAGES = [
  { code: 'pt-BR', flag: '🇧🇷', label: 'Português (Brasil)' },
  { code: 'es', flag: '🇪🇸', label: 'Español' }
];

export default {
  name: 'LanguageSelector',

  computed: {
    currentLocale() {
      return this.$store.getters[OPTIONS_STORE_LOCALE.GETTERS.CURRENT_LOCALE];
    },

    currentLanguage() {
      return AVAILABLE_LANGUAGES.find((l) => l.code === this.currentLocale) || AVAILABLE_LANGUAGES[0];
    },

    currentLanguageLabel() {
      return this.currentLanguage.label;
    },

    availableLanguages() {
      return AVAILABLE_LANGUAGES;
    }
  },

  methods: {
    selectLanguage(code) {
      this.$store.dispatch(OPTIONS_STORE_LOCALE.ACTIONS.SET_LOCALE, code);
      this.$i18n.locale = code;
      this.$vuetify.lang.current = VUETIFY_LOCALE_MAP[code] || 'pt';
      applyDocumentLocale(code);
      clearUrlLocale();
    }
  }
};
</script>
